export default function displayPlaceTelJobsInConsole() {
  console.group();
  console.log(
    '\n%c Hello %cPlace%ctel%c seekers 😎, \n\n the answer is %c42%c! \n\n Not what you are looking for? \n Then take a look at https://www.placetel.de/jobs\n\n',
    'background:rgba(0,0,0,0.05);color:inherit',
    'background:rgba(0,0,0,0.05);color:#1c9ee2;font-weight: bold;',
    'background:rgba(0,0,0,0.05);color:#6ab32d;font-weight: bold;',
    'background:rgba(0,0,0,0.05);color:inherit;font-weight: normal;',
    'background:rgba(0,0,0,0.05);color:#eb5f21;font-weight: bold;',
    'background:rgba(0,0,0,0.05);color:inherit;font-weight: normal;'
  );
  console.groupEnd();
}
